export default {
    data: {
        accessibility: {
            classMapping: undefined,
            isToolEnabled: undefined,
        },
        anniversary: {
            imageSrc: undefined,
            videoSrc: undefined,
            thumbnailSrc: undefined,
            logoSrc: undefined,
            learnMoreUrl: undefined,
            isEnabled: undefined,
        },
        app: {
            appVersion: undefined,
            backendType: undefined,
            baseName: undefined,
            defaultVeevImage: undefined,
            deviceListOrder: undefined,
            env: undefined,
            isAccessProtected: undefined,
            isDataCollectionEnabled: undefined,
            isDeviceSettingAvailable: undefined,
            isQualtricsTrackingEnabled: undefined,
            isReconnectDeviceGuideEnabled: undefined,
            isRememberMeEnabled: undefined,
            isTestLoginEnabled: undefined,
            isTipsAndTutorialsMenuItemEnabled: undefined,
            publicUrl: undefined,
            yapMode: undefined,
            rtlLanguageCodes: undefined,
            isBrowserCompatiblePageEnabled: undefined,
            isQuickStartGuidePageEnabled: undefined,
            quickStartGuideBanner: undefined,
            isWarningIconEnabled: undefined,
            toastNotificationDisplayTime: undefined,
            isDeviceBusyMessageEnabled: undefined,
            isPairingDelayOnWindowsEnabled: undefined,
            isUnderlineAnimationDisabled: undefined,
            isSuccessfullyUpdatedPageIconEnabled: undefined,
            hidePartOfCodentify: undefined,
        },
        appLinks: {
            linkAndroidStoreChrome: undefined,
            linkAndroidStoreEdge: undefined,
            linkAndroidStoreIqos: undefined,
            linkDesktopApps: undefined,
            linkDesktopChrome: undefined,
            linkDesktopEdge: undefined,
            linkAppGalleryEdge: undefined,
            linkIosStoreBluenet: undefined,
            linkIosStoreIqos: undefined,
            linkMacWidget: undefined,
            linkWindowsWidget: undefined,
        },
        aws: {
            awsRegion: undefined,
        },
        benefitPage: {
            isBenefitPageEnabled: undefined,
            benefitSections: undefined,
            imageSrc: undefined,
        },
        connectivity: {
            isBle: undefined,
            isUsb: undefined,
        },
        contactUs: {
            isCallUsSection: undefined,
            messageUsSection: {
                contactType: undefined,
            },
        },
        consumerServices: {
            isDeviceListEnabled: undefined,
            isDeviceRegistrationEnabled: undefined,
            isDeviceRenameEnabled: undefined,
            isDeviceUnregistrationEnabled: undefined,
            isTNCEnabled: undefined,
            isUnitedTNCEnabled: undefined,
            isNonMandatoryRegistrationEnabled: undefined,
            isRegistrationPromoted: undefined,
        },
        deviceConnectionType: {
            bleDisabled: [],
        },
        deviceDiagnostic: {
            connectCare: undefined,
            advancedDiagnostic: undefined,
            isErrorCodeDisplayingEnabled: undefined,
            isQuestionnaireEnabled: undefined,
            questionnaireDisabled: [],
            finishDeviceDiagnosticButtonDisplayTime: undefined,
            maxFailedAttempts: undefined,
            maxSuccessfulAttempts: undefined,
        },
        deviceFeatures: {
            isDeviceAlarmEnabled: undefined,
            isLedEnabled: undefined,
            isParentProtectionEnabled: undefined,
            isResponsiveDrawProfileEnabled: undefined,
            isSelfCleaningEnabled: undefined,
            isVapeCloudSizeEnabled: undefined,
            isVibrationEnabled: undefined,
            isAutoStartEnabled: undefined,
            isGestureEnabled: undefined,
            isSessionProfilingEnabled: undefined,
            isDeviceResetEnabled: undefined,
            isAemFlexBatteryEnabled: undefined,
            isFlexPuffEnabled: undefined,
            manualUpdateDeviceInfoEnabled: [],
            remainingSticksEnabled: [],
        },
        deviceSupport: {
            enableCortezSupport: undefined,
            enableCosmosSupport: undefined,
            enableDeltaSupport: undefined,
            enableOrdinarySupport: undefined,
            enableP4Support: undefined,
            enableSoyuzSupport: undefined,
            enableVespucciSupport: undefined,
            enableOriginalOneSupport: undefined,
            enableArianeSupport: undefined,
            enableOriginalDuoSupport: undefined,
            enableVoyagerSupport: undefined,
            enableHermesPrimeSupport: undefined,
            enableHermesMidSupport: undefined,
            enableHermesBetaSupport: undefined,
            enableJunoSupport: undefined,
            enableAlphaSupport: undefined,
        },
        externalLinks: {
            connectingCareUrl: undefined,
            contactUsEmail: undefined,
            dcsRegisterUrl: undefined,
            dcsSupportUrl: undefined,
            iqosHomeUrl: undefined,
            iqosHavUrl: undefined,
            iqosStoreUrl: undefined,
            learnMoreUrl: undefined,
            loginUrl: undefined,
            productRegistrationUrl: undefined,
            loyaltyClubDashboardUrl: undefined,
            loyaltyClubHomepageUrl: undefined,
            productUnregistrationUrl: undefined,
            tradeInUrl: undefined,
            privacyNoticeUrl: undefined,
            manualActivationUrl: undefined,
            leviaLearnMoreUrl: undefined,
            learnHowToUseUrl: undefined,
        },
        firmwareReleaseNotes: {
            isEnabled: undefined,
            changesIcons: [],
            isBannerEnabled: undefined,
            bannerLearnMoreUrl: undefined,
        },
        fwu: {
            bleDisabled: [],
            ble: [],
            isBackgroundFwuCheckEnabled: undefined,
            usb: [],
            areNewPopupsEnabled: undefined,
            reconnectAnimationVideo: undefined,
        },
        gam: {
            gamApiUrl: undefined,
            gamWssUrl: undefined,
            gigyaRefreshUrl: undefined,
            gigyaApiKey: undefined,
        },
        hav: {
            isHAVMandatory: undefined,
            isMarketHAVAvailable: undefined,
        },
        homePage: {
            isHomePageEnabled: undefined,
            isUsageEnabled: undefined,
            forYouSection: {
                externalLinkBannners: {
                    isBannerEnabled: undefined,
                    banners: [
                        {
                            bannerUrl: undefined,
                            bannerImage: undefined,
                            isDarkBannerText: undefined,
                        },
                        {
                            bannerUrl: undefined,
                            bannerImage: undefined,
                            isDarkBannerText: undefined,
                        },
                    ],
                },
                leviaBanner: {
                    isBannerEnabled: undefined,
                    bannerImage: undefined,
                    isDarkBannerText: undefined,
                },
                tradeInBanner: {
                    isBannerEnabled: undefined,
                    bannerImage: undefined,
                    isDarkBannerText: undefined,
                },
                learnHowToUse: {
                    DEV_TYPE_V24P_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V30_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V31_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V30M: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V31_ORIGINALS_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V31M: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1_ARIANE: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P4_M3_G2: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V40V_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V40C_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V40D_CONTROL: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V41P_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V41M_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V41B_CHARGER: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                    DEV_TYPE_P1V41J_CONTROL: {
                        isBannerEnabled: undefined,
                        bannerImage: undefined,
                        isDarkBannerText: undefined,
                        action: undefined,
                    },
                },
            },
        },
        icc: {
            anonymousToken: undefined,
            dataUserToken: undefined,
            iccApiBodyScope: undefined,
            iccApiHeader_a: undefined,
            iccApiHeader_m: undefined,
            iccApiHeaderAuthorization: undefined,
            iccApiHeaderUsername: undefined,
            iccApiUrl: undefined,
            iccAuthUrl: undefined,
        },
        levia: {
            isIlumaLeviaUsageEnabled: undefined,
            isLeviaConsumablesEnabled: undefined,
            leviaConsumablesIcons: [],
            eligibleForLeviaEnabled: [],
        },
        lifestyleImages: {
            DEV_TYPE_V24_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_V24P_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V30_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V30M: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V31M: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V31_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V31_ORIGINALS_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P4_M3_G2: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V40V_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V40C_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V40D_CONTROL: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V41P_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V41M_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V41B_CHARGER: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V41J_CONTROL: {
                deviceSettingsImage: undefined,
            },
            DEV_TYPE_P1V41A_CONTROL: {
                deviceSettingsImage: undefined,
            },
        },
        localization: {
            localizationFileName: undefined,
            localizationKey: undefined,
            localizationMapping: undefined,
        },
        login: {
            privacyNoticeUrl: undefined,
            ageGateMinAge: undefined,
            loginEmailRegex: undefined,
            loginForgotPasswordUrl: undefined,
            loginPasswordRegex: undefined,
            loginRegisterUrl: undefined,
        },
        logs: {
            awsLogLevel: undefined,
            isAppVersionVisible: undefined,
            isAwsLoggingEnabled: undefined,
            isDebug: undefined,
            isLogsVisible: undefined,
            logLevel: undefined,
        },
        loyaltyClub: [],
        market: {
            dcs: {
                isDCS: undefined,
            },
            dce1: {
                isDCE1: undefined,
            },
            dce2: {
                isDCE2: undefined,
            },
            monolith: {
                isMonolith: undefined,
            },
        },
        manualRegistration: {
            isManualRegistrationEnabled: undefined,
            manualRegistrationImages: {
                P4: {
                    manualRegistrationImagePath: undefined,
                },
                P1: {
                    manualRegistrationImagePath: undefined,
                },
                P1_V4: {
                    manualRegistrationImagePath: undefined,
                },
            },
        },
        manualActivation: [],
        muleSoft: {
            apiUrl: undefined,
            clientId: undefined,
            country: undefined,
        },
        promo: {
            tryFeature: {
                isTryFeatureEnabled: undefined,
                tryFeatureAvailabilityDays: undefined,
                supportedDeviceFeatures: {
                    DEV_TYPE_V24P_CHARGER: {
                        isCleaningModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                        isConnectCareEnabled: undefined,
                    },
                    DEV_TYPE_P1V30_CHARGER: {
                        isCleaningModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isConnectCareEnabled: undefined,
                    },
                    DEV_TYPE_P1V30M: {
                        isVibrateModeEnabled: undefined,
                        isConnectCareEnabled: undefined,
                    },
                    DEV_TYPE_P1V31M: {
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V31_CHARGER: {
                        isCleaningModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isConnectCareEnabled: undefined,
                        isAdvancedDiagnosticModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V31_ORIGINALS_CHARGER: {
                        isCleaningModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                        isConnectCareEnabled: undefined,
                        isAdvancedDiagnosticModeEnabled: undefined,
                    },
                    DEV_TYPE_P4_M3_G2: {
                        isLedModeEnabled: undefined,
                        isResponsiveDrawModeEnabled: undefined,
                        isVapeCloudSizeModeEnabled: undefined,
                        isVapeSessionModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V40V_CHARGER: {
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isAutoStartModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                        isAdvancedDiagnosticModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V40C_CHARGER: {
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isAutoStartModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V40D_CONTROL: {
                        isVibrateModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isAutoStartModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                    },
                    DEV_TYPE_P1_ARIANE: {
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V41P_CHARGER: {
                        isAutoStartModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V41M_CHARGER: {
                        isAutoStartModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V41B_CHARGER: {
                        isAutoStartModeEnabled: undefined,
                        isCountdownModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                    },
                    DEV_TYPE_P1V41J_CONTROL: {
                        isAutoStartModeEnabled: undefined,
                        isGestureModeEnabled: undefined,
                        isLedModeEnabled: undefined,
                        isVibrateModeEnabled: undefined,
                    },
                },
            },
            getFeature: {
                isGetFeatureEnabled: undefined,
                supportedDeviceFeatures: {
                    DEV_TYPE_V24P_CHARGER: {
                        CLEANING: {
                            image: undefined,
                        },
                        VIBRATION: {
                            image: undefined,
                        },
                        LOCATE_MY_DEVICE: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V30_CHARGER: {
                        CLEANING: {
                            image: undefined,
                        },
                        LED: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V30M: {
                        CLEANING: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V31M: {},
                    DEV_TYPE_P1V31_CHARGER: {
                        DEVICE_PARENT_PROTECTION: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V31_ORIGINALS_CHARGER: {
                        DEVICE_PARENT_PROTECTION: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P4_M3_G2: {
                        DEVICE_RESET: {
                            image: undefined,
                        },
                        VAPE_SESSION: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V40V_CHARGER: {
                        GESTURE: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V40C_CHARGER: {
                        GESTURE: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V40D_CONTROL: {},
                    DEV_TYPE_P1_ARIANE: {
                        DEVICE_PARENT_PROTECTION: {
                            image: undefined,
                        },
                    },
                    DEV_TYPE_P1V41P_CHARGER: undefined,
                    DEV_TYPE_P1V41M_CHARGER: undefined,
                    DEV_TYPE_P1V41B_CHARGER: undefined,
                    DEV_TYPE_P1V41J_CONTROL: undefined,
                },
            },
        },
        pwa: {
            isPwaEnabled: undefined,
            isPwaDesktopEnabled: undefined,
            isWebAppJourneyDisabled: undefined,
        },
        restrictedMarket: {
            isRestrictedMarket: undefined,
            restrictedAssetsImagePath: undefined,
        },
        scp: {
            scpApiUrl: undefined,
            scpCloudTopicMarket: undefined,
            scpCloudTopicMarketPrefix: undefined,
        },
        storage: {
            assetsPath: undefined,
            browserCheckPageImagePath: undefined,
            holderAssetsPath: undefined,
            path: undefined,
            externalConfig: {
                folderName: undefined,
                linksFileName: undefined,
                videoGuidesConfigFileName: undefined,
            },
            reconnectGuideAssetsPath: undefined,
            welcomePageImagePath: undefined,
            legalDisclaimerPdfName: undefined,
            tradeIn: {
                bigBanner: undefined,
                smallBanner: undefined,
            },
            levia: {
                bigBanner: undefined,
                smallBanner: undefined,
            },
            learnMore: {
                bigBanner: undefined,
                smallBanner: undefined,
            },
        },
        purchaseDate: {
            isPurchaseDateEnabled: undefined,
            localizations: [
                {
                    language: undefined,
                    datePickerLanguage: undefined,
                    inputMask: undefined,
                    dateFormat: undefined,
                },
            ],
            minDateYearLimitation: undefined,
            calendarStartDay: undefined,
        },
        tracking: {
            isAmplitudeEnabled: undefined,
            isGAEnabled: undefined,
        },
        usage: {
            isUsageAvailableP1: undefined,
            isUsageAvailableAriane: undefined,
            isUsageAvailableP4: undefined,
            isUsageAvailableP1V4: undefined,
            isFirstDaySunday: undefined,
            is12HoursToggleEnabled: undefined,
            maximumTimeDeltaInS: undefined,
            isNbw2UsageEnabled: undefined,
        },
        tipsAndTricksPage: {
            tipsAndTricksSections: undefined,
        },
        pauseModeGuide: {
            pauseModeGuideEnabled: [],
            isAutoSlideEnabled: undefined,
            isClosePauseModePopup: undefined,
        },
        tradeInBannerEnabled: undefined,
        i18n: {
            isFirstDaySunday: undefined,
            localizationCodes: [],
        },
        welcomePwa: {
            tipsIcons: [],
            videoSrc: undefined,
            thumbnailSrc: undefined,
            imageSrc: undefined,
            buttonLink: undefined,
        },
    },
};
